/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
		var main_controller = new ScrollMagic.Controller();
		
		var article_z = 0;
		$('article').each(function(){
			article_z++;
			$(this).css('z-index', article_z);
		    var currentArticle = this;
		
		    var tweenStrong = new TimelineMax()
		        .to(currentArticle, 2, {css: {opacity: 1}});

		    var scene = new ScrollMagic.Scene({
				triggerElement: currentArticle,
				reverse: true
				})
		        .setTween(tweenStrong)
		        .addTo(main_controller);
		});
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
		var home_controller = new ScrollMagic.Controller();
		var fadeout_rain = TweenMax.to('.rain', 2,{ opacity: 0 });
		
		var fadeout_scene = new ScrollMagic.Scene({
		  triggerElement: '#background-trigger',
		  reverse: true
		})
		.setTween(fadeout_rain)
		.addTo(home_controller);
		
		new ScrollMagic.Scene({triggerElement: ".full.white"})
			.setTween(".full.white > .feat-img img", {y: "-65%", ease: Elastic})
			.addIndicators()
			.addTo(home_controller);
		
/*		var fadeout_sun = TweenMax.to('.sun', 2,{ opacity: 0 });
		
		var fadeout_sun_scene = new ScrollMagic.Scene({
		  triggerElement: '.full.white',
		  reverse: true
		})
		.setTween(fadeout_sun)
		.addTo(home_controller);*/
		
		// JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
